import React from "react";
import ReactApexChart from "react-apexcharts";

const StartedStudentsChart =
({
    data = [],
    categories = [],
    title = "عدد الطلاب الذين بدأوا البرامج في كل الجامعات",
    color = "#00b894",
  }) => {
    const series = [
      {
        name: title,
        data: data,
      },
    ];
  
    const options = {
      chart: {
        height: 350,
        type: "area",
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: [3],
        colors: [color],
        curve: "smooth",
      },
      xaxis: {
        categories: categories,
        title: {
          text: "الجامعة",
          style: {
            fontSize: "14px",
            fontFamily: "Cairo",
          },
        },
        labels: {
          style: {
            fontFamily: "Cairo",
          },
        },
      },
      yaxis: {
        labels: {
          formatter: (val) => `${val}`,
        },
        title: {
          style: {
            fontSize: "14px",
            fontFamily: "Cairo",
          },
        },
      },
      markers: {
        size: [6],
        strokeWidth: [3],
        strokeColors: [color],
        colors: ["#fff"],
        hover: {
          size: 8,
        },
      },
      colors: [color],
      tooltip: {
        y: {
          formatter: (val) => `${val} طالب`,
        },
      },
    };
  
    return (
      <div className="card mt-4 p-3">
        <h5 className="mb-3">{title}</h5>
        <ReactApexChart options={options} series={series} type="area" height={350} />
      </div>
    );
  };

export default StartedStudentsChart;
